export const apiSearchBySlug = slug => `/1.0/client/${slug}/search`
export const apiCreateCertificate = `/1.0/client/create`
export const apiRegister = `/1.0/client/register/collaborator`
export const apiDetailOrder = id => `/1.0/client/${id}/search/detal`
export const apiRenew = id => `/1.0/client/${id}/renew`
export const apiGetPrice = `/1.0/client/totalPrice`
export const apiGetVehiceType = `/1.0/client/carlist`
export const apiGetListGift = `/1.0/client/gift/listAll`
export const apiSearch = slug => `/1.0/client/${slug}/search/order`
export const apiGetCarBrand = `/1.0/client/call_hieu_xe`
export const apiGetCarCompany = `/1.0/client/hang_xe`
export const apiCreateCertificateMotor = `/1.0/client/create/motorcycle`
export const apiGetPriceMotor = `/1.0/client/pvi/price/moto`